import { GlobalStyles } from '@mui/material'

import { useOlCesium } from './use-ol-cesium'

/**
 * Projects the OpenLayers map into a Cesium globe while 3D is enabled.
 *
 * Renders nothing of its own: ol-cesium inserts its canvas into the OL map's
 * viewport. Must be mounted *after* FarmtrxMap, because ol-cesium refuses to
 * start until the OL map has a target and a size, and FarmtrxMap is what calls
 * setTarget.
 */
export default function ThreeDMap({ mapRef = 'map' }: { mapRef?: string }) {
  useOlCesium(mapRef)

  return (
    <GlobalStyles
      styles={{
        // ol-cesium's entire stylesheet is this one rule. Inlined rather than
        // imported from the package so the 3D CSS does not enter the main
        // bundle for the majority of sessions that never turn 3D on.
        '.olcs-hideoverlay': { visibility: 'hidden' },
        // ol-cesium appends its canvas container to the viewport after
        // .ol-overlaycontainer-stopevent, so without this the globe paints over
        // the Zoom, ZoomSlider and Attribution controls — including the Esri
        // credit, which has to stay visible.
        '.ol-viewport .ol-overlaycontainer-stopevent': { zIndex: 2 },
      }}
    />
  )
}
